import type { AnyFormApi } from "@tanstack/react-form";

/**
 * The one submit entry point.
 *
 * `form.handleSubmit()` returns before `validateAllFields("submit")` whenever
 * `canSubmit` is false (form-core FormApi.js:461) — so on an already-touched
 * invalid form it neither submits NOR writes the per-field `errorMap.onSubmit`
 * that reveals what is wrong: the user presses the button and sees nothing at
 * all. Validating first closes that hole. It also means the submit button never
 * has to be disabled for invalidity.
 */
export async function submitForm(form: AnyFormApi): Promise<void> {
  if (form.state.isSubmitting) return;
  if (!form.state.canSubmit) {
    // validateAllFields runs FIELD validators with skipFormValidation, which is
    // a no-op under the policy's form-level schema — form.validate("submit") is
    // what writes each field's errorMap.onSubmit and makes the errors visible.
    await form.validateAllFields("submit");
    await form.validate("submit");
  }
  await form.handleSubmit();
}
